import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0517 from "../lesson-17/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "9a2addca-655e-4197-8143-29059af92e06",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0517),
    lesson: lesson0517,
  },
];

export default lessonLinks;
